import store from './store'
import { ACompetition } from 'kuaidong-api'
import { CompetitionType } from 'kuaidong-model'
import { getModule, Module, Mutation, VuexModule, Action } from 'vuex-module-decorators'
@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'competition',
})
class CompetitionModule extends VuexModule {
  types: CompetitionType[] = []
  currentCompetitionTitle = ''
  curV2CompetitionId = ''
  currentCompetitionDrillTitle = ''
  typesPromise: Promise<CompetitionType[]> | null = null

  @Mutation
  reset() {
    this.types = []
  }

  @Mutation
  setTypes(types: CompetitionType[]) {
    this.types = types
  }

  @Mutation
  setTypesPromise(typesPromise: Promise<CompetitionType[]>) {
    this.typesPromise = typesPromise
  }

  @Mutation
  setCurrentCompetitionTitle(title: string) {
    this.currentCompetitionTitle = title
  }
  @Mutation
  setCurrentV2CompetitionID(id: string) {
    this.curV2CompetitionId = id
  }
  @Mutation
  setCurrentCompetitionDrillTitle(title: string) {
    this.currentCompetitionDrillTitle = title
  }

  @Action
  async loadTypes() {
    const typesPromise = ACompetition.fetchTypes()

    this.context.commit('setTypesPromise', typesPromise)

    this.context.commit('setTypes', await typesPromise)
  }

  @Action
  async ensureTypesIsLoaded() {
    if (this.typesPromise === null) {
      this.loadTypes()
    }

    return this.typesPromise
  }

  get typeIdTypeMap() {
    return this.types.reduce((result: { [index: string]: CompetitionType }, type) => {
      result[type.competition_type_id] = type
      return result
    }, {})
  }

  get drillIdTypeMap() {
    return this.types.reduce((result: { [index: string]: CompetitionType }, type) => {
      result[type.item_name] = type
      return result
    }, {})
  }
}

export default getModule(CompetitionModule)
